"use strict";

var homeExternalCircles = document.querySelector('.service-circles__external-circle');

if (homeExternalCircles) {
  var checkCirclePoints = function checkCirclePoints() {
    var innerCircle = document.querySelector('.service-circles__internal-circle'),
        externalCircle = document.querySelector('.service-circles__external-circle'),
        innerCirclePoint = document.querySelector('.service-circles__internal-point'),
        externalCirclePoint = document.querySelector('.service-circles__point');
    setCirclePointsPosition('.service-circles__internal-point', innerCirclePoint.clientWidth / 2, innerCircle.clientWidth / 2);
    setCirclePointsPosition('.service-circles__point', externalCirclePoint.clientWidth / 2, externalCircle.clientWidth / 2);
  };

  var setCirclePointsPosition = function setCirclePointsPosition(pointSelector, pointRadius, circleRadius) {
    var points = document.querySelectorAll(pointSelector);

    for (var index = 0; index < points.length; ++index) {
      var degreeSeparation = Math.round(360 / points.length),
          radianSeparation = degrees_to_radians(degreeSeparation);
      var x = Math.round(circleRadius * Math.cos(radianSeparation * (index + 1))) + circleRadius - pointRadius,
          y = Math.round(circleRadius * Math.sin(radianSeparation * (index + 1))) + circleRadius - pointRadius;
      var point = points[index];
      point.style.left = x + 'px';
      point.style.top = y + 'px';
    }
  };

  var degrees_to_radians = function degrees_to_radians(degrees) {
    var pi = Math.PI;
    return degrees * (pi / 180);
  };

  window.addEventListener("resize", checkCirclePoints, false);
  checkCirclePoints();
}